module.exports = __webpack_public_path__ + "static/media/national.75c828d2.jpg";